import type { SupplierPrepaymentApContractorLookupDto } from '../Types/bankDocument.types';

export interface BankDocumentApContractorLookup {
  id: number;
  name: string;
  nip: string;
}

export const mapApContractorLookup = (
  apContractor: SupplierPrepaymentApContractorLookupDto | undefined | null
): BankDocumentApContractorLookup | undefined => {
  if (!apContractor) {
    return undefined;
  }

  return {
    id: apContractor.id,
    name: apContractor.name,
    nip: apContractor.nip,
  };
};
